import type { Story } from '@/store/story-types'

export const CREATOR_BLOG_STORY: Story = {
  id: 'creator-blog-1',
  name: 'Creator Blog',
  narrative: 'A minimal blog with newsletter signup where creators publish articles, showcase featured posts, and grow their audience — inspired by Medium and Substack.',
  goals: ['Publish articles', 'Highlight featured content', 'Grow newsletter subscribers', 'Enable post reading'],
  lifecycle: 'building',
  pages: [
    { id: 'pg-home', title: 'The Creative Journal', order: 0, status: 'draft', elementCount: 5, linkedPageId: 'home', description: 'Blog home with header, featured post, post list, newsletter signup, and footer',
      blockRef: { category: 'blog', blockId: 'blog-header' } },
    { id: 'pg-post', title: 'Post', order: 1, status: 'draft', elementCount: 3, linkedPageId: 'post', description: 'Individual post page with header, full content, and footer',
      blockRef: { category: 'blog', blockId: 'post-content' } },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Posts',
      description: 'Visitor sees the featured post and post list on the homepage',
      steps: [
        { type: 'given', text: 'the visitor is on the blog homepage' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'a featured post card and a list of recent posts are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Read Post',
      description: 'Visitor opens and reads a full blog post',
      steps: [
        { type: 'given', text: 'the visitor sees a post in the list' },
        { type: 'when', text: 'they click on the post title' },
        { type: 'then', text: 'the full post content with title, date, and body is displayed', linkedPageId: 'post' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Subscribe to Newsletter',
      description: 'Visitor subscribes via the newsletter signup form',
      steps: [
        { type: 'given', text: 'the visitor is on the blog homepage' },
        { type: 'when', text: 'they enter their email and click Subscribe' },
        { type: 'then', text: 'a confirmation message is shown', linkedFlowId: 'subscribeNewsletter' },
      ],
    },
  ],
}
